import { useGaugeChartFormatterContext } from './useGaugeChartFormatterContext.js';
import { useGaugeChartRangeMaxContext } from './useGaugeChartRangeMaxContext.js';
import { useGaugeChartRangeMinContext } from './useGaugeChartRangeMinContext.js';

export const useDefaultLabels = (value: number) => {
  const min = useGaugeChartRangeMinContext();
  const max = useGaugeChartRangeMaxContext();
  const formatter = useGaugeChartFormatterContext();

  const defaultLabel = `${formatter(value)} / ${formatter(max)}`;
  const defaultMaxLabel = `${formatter(max)}`;
  const defaultMinLabel = `${formatter(min)}`;
  const defaultValueLabel = `${formatter(value)}`;

  return {
    defaultLabel,
    defaultMaxLabel,
    defaultMinLabel,
    defaultValueLabel,
  };
};
